import { __decorate } from "tslib";
import { FASTElement, observable } from "@microsoft/fast-element";
import { StartEnd, applyMixins } from "@microsoft/fast-foundation";
import { keyCodeEnter, keyCodeSpace } from "@microsoft/fast-web-utilities";
import { throttle } from "lodash-es";
export class FeedNavigation extends FASTElement {
    constructor() {
        super(...arguments);
        /** Localized strings used for tool tip and aria-label */
        this.localizedStrings = {};
        /** Flag to show/hide overflow button  */
        this.isOverflowing = false;
        /** Flag to show/hide overflow menu */
        this.showMenu = false;
        /** Items overflowing horizontal nav, these will be shown in overflow menu */
        this.overflowItems = [];
        /** ResizeObserver instance that watches for horizontal nav container resize event */
        this.resizeObserver = new window.ResizeObserver(throttle(this.onContainerResize.bind(this), 200));
        /** Nav item click handler */
        this.onNavItemClick = (selectedNav) => {
            const itemId = selectedNav.id;
            this.activeId = itemId;
            this.change(selectedNav);
            this.showMenu = false;
        };
        this.onNavItemKeyPress = (event, selectedNav) => {
            const { keyCode } = event;
            if (keyCode !== keyCodeEnter && keyCode !== keyCodeSpace) {
                return;
            }
            this.onNavItemClick(selectedNav);
            event.preventDefault();
        };
        /** Overflow menu button click handler  */
        this.toggleOverflowMenu = (event) => {
            event.stopPropagation();
            if (this.showMenu === true) {
                this.hideOverflowMenu();
            }
            else {
                this.showOverflowMenu();
            }
        };
        this.change = (navItem) => {
            this.$emit("change", { selectedNav: navItem });
        };
        this.onClickOutside = (event) => {
            if (event.target instanceof FeedNavigation) {
                return;
            }
            this.hideOverflowMenu();
        };
    }
    /**
     * Connected callback
     */
    connectedCallback() {
        super.connectedCallback();
        this.resizeObserver.observe(this.navContainer);
    }
    /**
     * Disconnected callback
     */
    disconnectedCallback() {
        super.disconnectedCallback();
        this.resizeObserver.disconnect();
    }
    /**
     * Data change subscription
     * @param oldValue - old value
     * @param newValue - new value
     */
    dataChanged(oldValue, newValue) {
        if (!newValue || !newValue.length) {
            return;
        }
        this.activeId = null;
        newValue.forEach((item, index) => {
            item.id = item.id || `nav-${index}`;
            if (!this.activeId && item.isActive === true) {
                this.activeId = item.id;
            }
        });
        if (oldValue) {
            requestAnimationFrame(() => {
                this.onContainerResize();
                if (this.activeId) {
                    const activeElement = this.navContainer.querySelector(`#${this.activeId}`);
                    activeElement && activeElement.focus();
                }
            });
        }
    }
    showOverflowMenu() {
        this.showMenu = true;
        document.addEventListener("click", this.onClickOutside);
    }
    hideOverflowMenu() {
        this.showMenu = false;
        document.removeEventListener("click", this.onClickOutside);
    }
    onContainerResize() {
        this.overflowItems = [];
        this.showMenu = false;
        let width = 0;
        const containerWidth = this.navContainer.offsetWidth;
        Array.from(this.navContainer.children).forEach((navElement, index) => {
            const navItem = this.data[index];
            if (!navItem) {
                return;
            }
            width += navElement.offsetWidth;
            if (width > containerWidth) {
                this.overflowItems.push(navItem);
                navElement.classList.add("hidden");
            }
            else {
                navElement.classList.remove("hidden");
            }
        });
        this.isOverflowing = !!this.overflowItems.length;
    }
}
__decorate([
    observable
], FeedNavigation.prototype, "data", void 0);
__decorate([
    observable
], FeedNavigation.prototype, "localizedStrings", void 0);
__decorate([
    observable
], FeedNavigation.prototype, "activeId", void 0);
__decorate([
    observable
], FeedNavigation.prototype, "isOverflowing", void 0);
__decorate([
    observable
], FeedNavigation.prototype, "showMenu", void 0);
__decorate([
    observable
], FeedNavigation.prototype, "overflowItems", void 0);
applyMixins(FeedNavigation, StartEnd);
